// activity-log.service.ts

import { http } from '@/app/lib/http/client'
import { ListParams } from '../types/pagination'

// ─── Interfaces ───────────────────────────────────────────────────────────────

export interface ActivityLog {
    id:            number
    event:         string
    description:   string
    subject_type:  string | null
    subject_id?:   number | null
    subject_name?: string | null
    causer_id?:    number | null
    causer_name:   string | null
    causer_email:  string | null
    sucursal_id?:  number | null
    sucursal_name: string | null
    changes?:      Record<string, { old: unknown; new: unknown }>
    properties?:   Record<string, unknown>
    created_at:    string
}

export interface ActivityLogFilters {
    all_sucursals?:  boolean
    event?:          string
    subject_type?:   string
    user_id?:        number
    sucursal_id?:    number
    from?:           string
    to?:             string
    search?:         string
}

// ─── Servicio ─────────────────────────────────────────────────────────────────

export const activityLogService = {
    async getLogs(params?: ListParams & ActivityLogFilters) {
        const response = await http.get('/activity-logs', { params })
        return response.data
    },

    async getLog(id: number) {
        const response = await http.get(`/activity-logs/${id}`)
        return response.data
    },
}